import api from './api';

export interface ResponsavelLogado {
  id: number;
  tipo: 'adv' | 'adm';
  nome: string;
}

const lerAcesso = (): { nivel: string; usuarioId: number } => {
  const accessData = localStorage.getItem('@Jurisnet:access');
  if (!accessData) return { nivel: '', usuarioId: 0 };
  const access = JSON.parse(accessData);
  return {
    nivel: access.nivelusuario,
    usuarioId: Number(access.usuario_logado),
  };
};

export async function buscarResponsavelLogado(): Promise<ResponsavelLogado | null> {
  const { nivel, usuarioId } = lerAcesso();

  if (nivel === 'Administrador') {
    const { data: administrador } = await api.get(
      `/management/administrators/show/${usuarioId}`,
    );
    const { data: advogado } = await api.get(
      `/management/attorneys/findbyemail/${administrador.administrador_email}`,
    );

    if (advogado && advogado.advogado_id) {
      return {
        id: advogado.advogado_id,
        tipo: 'adv',
        nome: advogado.advogado_nome,
      };
    }
    return {
      id: administrador.administrador_id,
      tipo: 'adm',
      nome: administrador.administrador_nome,
    };
  }

  if (nivel === 'Advogado') {
    const { data } = await api.get(`/management/attorneys/show/${usuarioId}`);
    return { id: data.advogado_id, tipo: 'adv', nome: data.advogado_nome };
  }

  if (nivel === 'Assistente') {
    const { data } = await api.get(
      `/management/administrators/show/${usuarioId}`,
    );
    return {
      id: data.administrador_id,
      tipo: 'adm',
      nome: data.administrador_nome,
    };
  }

  return null;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const mensagemDeErroDaApi = (error: any): string => {
  const corpo = error?.response?.data;
  if (typeof corpo === 'string' && corpo.length > 0 && corpo.length < 300)
    return corpo;
  return 'Tente repetir o cadastro ou contate o administrador.';
};
